// extracted by mini-css-extract-plugin
export default {"call":"Call_call__kuYm+","videoContainer":"Call_videoContainer__441eG","buttonContainer":"Call_buttonContainer__T2cC3"};